import React from 'react';
import { connect } from 'react-redux';
import { countByAttribute } from '@/utils/resultsHelper';
import { findWithUUID } from '@/utils/uuidHelper';
import SelectColumn from '@/components/table/SelectColumn';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import { resolveCatalogueTemplate } from '../../catalogue/helper';
import { datasetPerms } from '../../sharing/state/state';
import { toggleDictionaryFieldsProperty } from '../../dictionaries/actions';

const DictionaryFieldCohortFilterHeader = ({
  activeDictionaryUUID,
  allCohortFiltersSelected,
  canEdit,
  category,
  code,
  colWidth,
  indeterminateCohortFilterSelected,
  template,
  toggleDisabled,
  toggleFieldSettings,
}) => (
  <>
    {canEdit && (
      <SelectColumn
        key={`cohort_filter_default_indeterminate_${(indeterminateCohortFilterSelected || false).toString()}`}
        entity="field.cohort.filter"
        colWidth={colWidth}
        disabled={toggleDisabled}
        selected={allCohortFiltersSelected}
        defaultIndeterminate={indeterminateCohortFilterSelected}
        onCheckBoxClick={() => (
          toggleFieldSettings(
            category,
            code,
            activeDictionaryUUID,
            'cohort_filter',
            !allCohortFiltersSelected,
            template,
          )
        )}
        withLabel
      />
    )}
    {!canEdit && (<UnsortedColumn columnId="field.cohort.filter" colWidth={1} />)}
  </>
);

const mapStateToProps = ({
  catalogues: { templates },
  datasets: { datasets },
}, ownProps) => {
  const { dataset, template, editable } = resolveCatalogueTemplate(datasets, templates, ownProps, {
    dictionaries: [],
    permissions: datasetPerms(),
    activeDictionaryUUID: null,
  });

  const activeDictionary = findWithUUID(dataset.dictionaries, dataset.activeDictionaryUUID);
  const numberOfRows = activeDictionary?.fields?.length || 0;
  const toggleDisabled = numberOfRows === 0;
  const selectedCohortFilterFields = countByAttribute((activeDictionary?.fields || []), 'cohort_filter', true);
  const allCohortFiltersSelected = (!toggleDisabled && numberOfRows > 0)
    ? numberOfRows === selectedCohortFilterFields
    : false;
  const indeterminateCohortFilterSelected = (!toggleDisabled && numberOfRows > 0)
    ? (selectedCohortFilterFields > 0 && selectedCohortFilterFields < numberOfRows)
    : false;

  return (
    {
      allCohortFiltersSelected,
      activeDictionaryUUID: dataset.activeDictionaryUUID,
      disabled: !editable,
      indeterminateCohortFilterSelected,
      template,
      toggleDisabled,
    }
  );
};

const mapDispatchToProps = {
  toggleFieldSettings: toggleDictionaryFieldsProperty,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryFieldCohortFilterHeader);
